import React from "react";

import { IconMetrics } from "~/components/icon";
import { RemoteData } from "~/tools/remote-data";

import { DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";

import { AddToDashboardButton } from "./_add-to-dashboard-button";
import { Content } from "./_content";
import { PinComponentButton } from "./_pin-component-button";
import type { MetricsDrawerState } from "./state";

export interface MetricsDrawerProps {
	when: undefined | MetricsDrawerState;
}

export const MetricsDrawer: React.FC<MetricsDrawerProps> = ({ when }) => (
	<ExplorationDrawer
		headerActions={({ timestamp, title, chart, metricQueries, componentIdOrIdentifier }) => (
			<>
				{componentIdOrIdentifier != null && (
					<PinComponentButton
						chart={chart}
						componentIdOrIdentifier={componentIdOrIdentifier}
						metricQueries={metricQueries}
						timestamp={timestamp}
						title={title}
					/>
				)}

				<AddToDashboardButton
					model={RemoteData.success({ title, metricQueries, chart, timestamp, componentIdOrIdentifier })}
				/>
			</>
		)}
		headerTitle={({ title = "" }) => <DrawerTitle icon={<IconMetrics height={20} width={20} />} title={title} />}
		when={when}
	>
		{({ chart, metricQueries, timestamp, timeRange }) => (
			<Content model={RemoteData.success({ chart, metricQueries })} timeRange={timeRange} timestamp={timestamp} />
		)}
	</ExplorationDrawer>
);
